export default {
  VALID_EMAIL_REGEX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  VALID_CONTACT_REGEX: /^[+\d][\d\s\-()]*$/,
  IS_IMAGE_URL: /\.(jpeg|jpg|gif|png|bmp|svg)$/i,
  EMAIL_REGEX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  POSITIVE_INTEGER_REGEX: /^\d+$/,
  NUMBER_REGEX: /^-?\d+(\.\d+)?$/,
  URL_REGEX: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/,
  PASSWORD_REGEX: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  ONE_UPPERCASE_REGEX: /^(?=.*[A-Z]).*$/,
  ONE_LOWERCASE_REGEX: /^(?=.*[a-z]).*$/,
  ONE_NUMBER_REGEX: /^(?=.*\d).*$/,
  ALL_SPECIAL_CHARACTERS_REGEX: /[@$!%*?&~`#^()_+\-=[\]{};':"\\|,.<>/?]/
}
